import LinkedIn_Icon from "../src/assets/images/LinkedIn_Icon.svg";
import githubIcon from "../src/assets/images/githubIcon.svg";
import Instagram_Icon from "../src/assets/images/Instagram_Icon.svg";

export const links = [
  {
    id: 1,
    imgSrc: LinkedIn_Icon ,
    url: "https://www.linkedin.com/in/mubassim",
    alt: "LinkedIn",
  },
  {
    id: 2,
    imgSrc: githubIcon,
    url: "https://www.github.com/Mubassim-Khan",
    alt: "GitHub",
  },
  {
    id: 3,
    imgSrc: Instagram_Icon,
    url: "https://www.instagram.com/mubassimahmedkhan",
    alt: "Instagram",
  },
];
